import React from 'react';
import { ActiveStatus } from '../../../../components';
import { Role } from '../../../../types';
import { ComingSoon } from '../ComingSoon/ComingSoon';
import { ImageLoadingBar } from '../ImageLoadingBar/ImageLoadingBar';
import { Toggle } from '../Toggle/Toggle';

type AppProps = {
  defaultActive?: boolean;
  preview: string;
  title: string;
  body: string;
  role?: Role;
  name?: string;
};

export const App: React.FC<AppProps> = ({
  defaultActive = false,
  preview,
  title,
  body,
  role,
  name,
}: AppProps): JSX.Element => {
  return (
    <div className="app">
      <ImageLoadingBar preview={preview} />
      <div className="app__content">
        <h1 className="app__content-title">{title}</h1>
        <p className="app__content-body">{body}</p>
        {defaultActive || title === 'Q beta for Email' ? (
          <a
            target="_blank"
            rel="noopener noreferrer"
            className="app__content-link"
            href="https://www.substrata.me/technology/overview/"
          >
            Read more
          </a>
        ) : (
          <ComingSoon />
        )}
      </div>
      {role !== 'dealmaker' ? (
        <Toggle
          serviceName={title}
          className="app__toggle"
          defaultActive={defaultActive}
          disabled={name !== 'email-analyzer'}
          appName={name}
        />
      ) : (
        <ActiveStatus
          status={defaultActive ? 'active' : 'inactive'}
          className="app__toggle"
        />
      )}
    </div>
  );
};
